import React, { useState } from 'react';
import SquareLoader from 'components/atoms/square_loader';
import { Container } from './styles';

interface TradingKeywordItemProps {
  keyword: string;
  deleteKeyword: () => void;
}

const TradingKeywordItem = (props: TradingKeywordItemProps) => {
  const { keyword, deleteKeyword } = props;
  const [deleting, setDeleting] = useState<boolean>(false);

  return (
    <Container>
      <div className="added-itens d-flex align-items-center mr-2 mb-2">
        <button
          type="button"
          className="btn position-relative btn-link btn-sm"
          onClick={() => {
            deleteKeyword();
            setDeleting(true);
          }}
        >
          {!deleting && 'x'}
          {deleting && <SquareLoader customClass="delete-word" />}
        </button>
        <span className="pr-2 pl-2">{keyword}</span>
      </div>
    </Container>
  );
};

export default TradingKeywordItem;
